import { render } from "./TrashFilesPage.vue?vue&type=template&id=c2385df8&ts=true"
import script from "./TrashFilesPage.vue?vue&type=script&lang=ts"
export * from "./TrashFilesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__